import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomButton from "../../Components/CustomButton";
import { axiosAPI } from "../../Axios/Axios";
import { errorNotify, succesNotify } from "../../CommonCode/Commonfunc";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ExitGroupModal({ open, handleClose, exitId, apiCall }) {
  const Labels = useSelector((state) => state.allLabels.labels);
  const redirect = useNavigate();
  const exitGroup = async () => {
    if (exitId) {
      try {
        const postData = {
          groupid: exitId,
          language:localStorage.getItem("language")
        };
        const result = await axiosAPI.post("/exitGroup", postData);
        const { status, message } = result.data;
        if (status) {
          succesNotify(message);
          setTimeout(() => {
            redirect("/myGroupList");
          }, 1000);
          handleClose();
        } else {
          errorNotify(message);
        }
      } catch (error) {
        //// console.log(error.message);
      }
    } else {
      //// console.log(" post id is not available to delete group");
    }
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: "300px",
          padding: "20px",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
        {Labels?.areYouSure}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{ textAlign: "center", fontFamily: "poppins" }}
        >
          {Labels?.wantToExit}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center", marginTop: "20px" }}>
        <CustomButton
          label={Labels?.exit}
          style={{
            width: 100,
            borderRadius: "3px",
            fontSize: "14px",
            mb: 2,
          }}
          onClick={exitGroup}
        />
        <CustomButton
          label={Labels?.Cancel}
          style={{
            width: 100,
            borderRadius: "3px",
            fontSize: "14px",
            mb: 2,
          }}
          onClick={handleClose}
        />
      </DialogActions>
    </Dialog>
  );
}
